export default "__VITE_ASSET__4d0ff827__"